@if (mostrarQrConexion()) {
  <app-mica-chat-qr-conexion [telefonoId]="telefonoId" (conectado)="onConexionEstablecida()" />
} @else {
  <div class="flex h-full min-h-0 flex-col lg:flex-row">
    @if (chatSeleccionado() == null || mostrarListaChatsMovil()) {
      <aside
        class="flex min-h-0 w-full flex-col border-b border-slate-200 bg-white lg:w-88 lg:border-b-0 lg:border-r"
        [class.hidden]="chatSeleccionado() != null && !mostrarListaChatsMovil()"
      >
        <div class="space-y-4 border-b border-slate-200 p-3 sm:p-4">
          <label
            class="flex items-center gap-3 rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-sm shadow-sm focus-within:border-sky-400 focus-within:ring-2 focus-within:ring-sky-100"
          >
            <span class="text-slate-400">&#8990;</span>
            <input
              class="w-full bg-transparent outline-none placeholder:text-slate-400"
              type="text"
              placeholder="Buscar conversaciones..."
            />
          </label>

          <div class="flex flex-wrap gap-2 text-xs font-medium">
            <button class="rounded-full bg-sky-100 px-3 py-1.5 text-sky-700 ring-1 ring-sky-200">
              Todos
            </button>
            <button
              class="rounded-full border border-slate-200 bg-white px-3 py-1.5 text-slate-600 transition hover:bg-slate-50"
            >
              No leidos
            </button>
            <button
              class="rounded-full border border-slate-200 bg-white px-3 py-1.5 text-slate-600 transition hover:bg-slate-50"
            >
              Favoritos
            </button>
          </div>
        </div>

        <section class="flex-1 overflow-y-auto bg-[#f7f8fc] px-4 py-4 sm:px-5">
          @for (chat of chats(); track $index) {
            <app-mica-chat-caja-chat [cajaChat]="chat" (click)="onSelectChat(chat)" />
          }
        </section>
      </aside>
    }

    <main class="flex min-h-0 min-w-0 flex-1 flex-col bg-[#f7f8fc]">
      @if (chatSeleccionado() != null) {
        <div class="h-full min-h-0">
          <app-mica-chat-caja-mensajes
            [chat]="chatSeleccionado()!"
            [mensajes]="mensajes()"
            (volver)="volverAChats()"
          />
        </div>
      }
    </main>
  </div>
}
